var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03107 12.42C2.39107 17.57 6.76107 21.76 11.9911 21.99C15.6811 22.15 18.9811 20.43 20.9611 17.72C21.7811 16.61 21.3411 15.87 19.9711 16.12C19.3011 16.24 18.6111 16.29 17.8911 16.26C13.0011 16.06 9.00107 11.97 8.98107 7.13996C8.97107 5.83996 9.24107 4.60996 9.73107 3.48996C10.2711 2.24996 9.62107 1.65996 8.37107 2.18996C4.41107 3.85996 1.70107 7.84996 2.03107 12.42Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.5087c1ad5dc7970b38a8b3d46c14820e.svg";
export { ForwardRef as ReactComponent };